import { TEAM } from "@/lib/clinic";
import { Heart } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 sm:py-24 lg:py-32"
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#3A564A]">
              <span className="h-px w-8 bg-[#3A564A]" />
              About the clinic
            </span>
            <h2 className="font-display font-bold text-stone-900 text-4xl sm:text-5xl tracking-tight mt-5 leading-[1.05]">
              Modern dental care, delivered with heart.
            </h2>
            <p className="mt-6 text-stone-600 leading-relaxed">
              Dent Square Dental Clinic, Lucknow is a modern dental care
              center led by{" "}
              <span className="font-semibold text-stone-900">
                Dr. Mohit Singh Raghuvanshi
              </span>{" "}
              and{" "}
              <span className="font-semibold text-stone-900">
                Dr. Priyanka Singh
              </span>
              , offering advanced treatments in Dental Implants,
              Single-Sitting Root Canal (RCT) and Dental Conservation.
            </p>
            <p className="mt-4 text-stone-600 leading-relaxed">
              Equipped with the latest technology and a focus on painless
              dentistry, the clinic ensures lasting oral health and beautiful
              smiles. Located in the heart of Lucknow, Dent Square is your
              trusted destination for expert dental care and personalised
              treatment plans.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-[#E08570]/10 border border-[#E08570]/30">
              <Heart className="w-4 h-4 text-[#E08570]" />
              <span className="text-sm font-semibold text-stone-900">
                Painless dentistry · Latest technology
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-5">
              {TEAM.map((m, i) => (
                <article
                  key={m.name}
                  data-testid={`team-card-${i}`}
                  className="group rounded-3xl bg-white border border-stone-200 overflow-hidden hover:-translate-y-1 hover:shadow-xl transition-all"
                >
                  <div className="aspect-[4/5] overflow-hidden bg-stone-100">
                    <img
                      src={m.image}
                      alt={m.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-5">
                    <h3 className="font-display font-bold text-stone-900 text-lg">
                      {m.name}
                    </h3>
                    <p className="text-xs font-semibold uppercase tracking-wider text-[#3A564A] mt-1">
                      {m.role}
                    </p>
                    <p className="mt-3 text-sm text-stone-600 leading-relaxed">
                      {m.bio}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
